import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Skeleton } from '../../components/ui/skeleton';
import { cn } from '../../lib/utils';

const StatsCard = ({ title, value, icon, trend, color, loading }) => {
  const getColorClass = () => {
    switch (color) {
      case 'primary':
        return 'bg-blue-500 text-white';
      case 'success':
        return 'bg-green-500 text-white';
      case 'info':
        return 'bg-purple-500 text-white';
      case 'warning':
        return 'bg-orange-500 text-white';
      case 'danger':
        return 'bg-red-500 text-white';
      case 'secondary':
        return 'bg-gray-500 text-white';
      default:
        return 'bg-blue-500 text-white';
    }
  };

  return (
    <Card className="shadow-sm border-0 h-full">
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-3">
          <div
            className={cn(
              'p-2 rounded',
              loading ? 'bg-gray-100' : getColorClass()
            )}
            style={{ width: 40, height: 40 }}
          >
            {icon}
          </div>

          {loading && <Skeleton className="w-[60px] h-5" />}
        </div>
        <div>
          <h3 className="text-2xl font-bold mb-1">
            {loading ? <Skeleton className="w-20 h-7" /> : value}
          </h3>
          <p className="text-muted-foreground text-sm mb-0">{title}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
